export default {
  path: '/printing_surfaces',
  name: 'printing_surfaces',
  component: () => import('../components/printingsurface/Layout'),
  redirect: { name: 'PrintingSurfaceList' },
  meta: {
    breadcrumb: 'printingsurface.printingsurfaces',
  },
  children: [
    {
      name: 'PrintingSurfaceList',
      path: '',
      component: () => import('../views/printingsurface/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'PrintingSurfaceCreate',
      path: 'new',
      component: () => import('../views/printingsurface/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'PrintingSurfaceUpdate',
      path: ':id/edit',
      component: () => import('../views/printingsurface/Update'),
      meta: {
        breadcrumb: 'printingsurface.printingsurface',
      },
    },
    {
      name: 'PrintingSurfaceShow',
      path: ':id',
      component: () => import('../views/printingsurface/Show'),
      meta: {
        breadcrumb: 'printingsurface.printingsurface',
      },
    }
  ]
};
